function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "agreement"
}, /*#__PURE__*/React.createElement("g", {
  id: "document"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  opacity: 0.5,
  d: "M541.416 0.0117749L75.1255 212.709L369.007 856.977L835.297 644.28L541.416 0.0117749Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M537.643 7.46436L83.2167 214.75L370.603 844.78L825.029 637.494L537.643 7.46436Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M416.157 42.7734L190.722 145.605L215.631 200.212L441.066 97.3806L416.157 42.7734Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M279.09 40.82C261.69 48.76 254.17 69.64 262.3 87.46C270.43 105.28 291.13 113.29 308.53 105.35C325.93 97.41 333.45 76.53 325.32 58.71C317.19 40.89 296.49 32.88 279.09 40.82ZM302.3 91.7C298.639 93.4763 294.531 94.1209 290.502 93.5517C286.472 92.9825 282.704 91.2253 279.678 88.5043C276.652 85.7834 274.506 82.2223 273.513 78.2759C272.521 74.3294 272.727 70.1766 274.106 66.3479C275.484 62.5191 277.973 59.1882 281.254 56.7805C284.534 54.3727 288.458 52.9975 292.524 52.8303C296.59 52.6631 300.613 53.7115 304.081 55.8418C307.548 57.972 310.302 61.0874 311.99 64.79C313.121 67.1938 313.768 69.797 313.894 72.4508C314.019 75.1047 313.621 77.7572 312.721 80.257C311.821 82.7568 310.437 85.0549 308.649 87.02C306.862 88.9851 304.704 90.5788 302.3 91.71V91.7Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M413.793 43.8972L193.108 144.562L216.921 196.767L437.606 96.1024L413.793 43.8972Z",
  fill: "#D4AF37"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M280.17 43.2C274.067 45.9826 268.927 50.5124 265.399 56.2165C261.871 61.9206 260.114 68.5429 260.349 75.2458C260.585 81.9486 262.803 88.4311 266.723 93.8732C270.643 99.3154 276.089 103.473 282.372 105.82C288.655 108.167 295.493 108.598 302.021 107.059C308.549 105.519 314.474 102.079 319.046 97.1722C323.619 92.2655 326.634 86.113 327.71 79.4928C328.785 72.8726 327.874 66.0821 325.09 59.98C321.358 51.7986 314.529 45.4347 306.105 42.2879C297.681 39.1411 288.352 39.4692 280.17 43.2V43.2ZM302.36 91.85C298.84 93.4546 294.924 93.9796 291.106 93.3586C287.288 92.7375 283.74 90.9984 280.91 88.361C278.08 85.7236 276.096 82.3064 275.208 78.5415C274.32 74.7765 274.569 70.8329 275.922 67.2091C277.276 63.5854 279.673 60.4442 282.811 58.1829C285.95 55.9215 289.688 54.6415 293.554 54.5045C297.42 54.3676 301.239 55.38 304.53 57.4137C307.82 59.4474 310.434 62.4111 312.04 65.93C314.192 70.6496 314.381 76.0306 312.565 80.8895C310.75 85.7484 307.079 89.6874 302.36 91.84V91.85Z",
  fill: "#D4AF37"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M248.419 262.666L151.123 307.048L195.504 404.343L292.8 359.962L248.419 262.666Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M336.699 455.325L239.403 499.707L283.785 597.002L381.08 552.621L336.699 455.325Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M246.475 267.851L156.303 308.982L197.435 399.154L287.607 358.022L246.475 267.851Z",
  fill: "#69F0AE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_10",
  d: "M333.612 458.87L243.44 500.001L284.571 590.173L374.743 549.042L333.612 458.87Z",
  fill: "#D4AF37"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_11",
  d: "M442.095 212.249L318.497 268.628L322.431 277.253L446.03 220.874L442.095 212.249Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_12",
  d: "M528.486 188.473L324.405 281.564L328.339 290.189L532.42 197.098L528.486 188.473Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_13",
  d: "M520.002 207.965L330.296 294.499L334.231 303.124L523.936 216.59L520.002 207.965Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_14",
  d: "M529.236 403.277L405.638 459.656L409.572 468.282L533.17 411.902L529.236 403.277Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_15",
  d: "M615.623 379.492L411.542 472.583L415.476 481.209L619.557 388.117L615.623 379.492Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_16",
  d: "M607.143 398.994L417.437 485.527L421.372 494.153L611.077 407.619L607.143 398.994Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_17",
  d: "M199.04 337.46L222.26 345L229.9 300.31L241.2 303.4L228.49 358.65L193.47 343.3L199.04 337.46Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_18",
  d: "M202 336.87L222.19 343.42L228.83 304.56L238.65 307.25L227.6 355.29L197.15 341.95L202 336.87Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_19",
  d: "M289.68 529.08L309.87 535.63L316.51 496.77L326.33 499.46L315.28 547.5L284.83 534.16L289.68 529.08Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_20",
  d: "M677.308 533.588L388.987 665.105L432.824 761.209L721.145 629.692L677.308 533.588Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_21",
  d: "M635.51 610.18C624.43 607.02 613.09 607.62 609.56 620.29C608.37 624.56 608.23 631.19 603.65 633.39C596.91 636.63 588.78 630.15 582.93 627.51C572.03 622.59 560.84 625.94 554.53 636.28C551.33 641.52 549.96 647.55 548.87 653.52C548.4 656.11 548.34 659.31 547.25 661.75C545.16 666.42 538.62 666 534.33 665.82C533.39 665.82 532.43 665.71 531.47 665.61C534.862 660.938 536.555 655.247 536.27 649.48C535.99 640.01 529.84 629.65 519.09 630.81C509.46 631.81 502.68 641.11 503.76 650.52C504.68 658.52 509.89 664.72 516.57 668.52C513.29 669.97 509.79 671.1 506.69 672.6C505.242 673.301 503.836 674.086 502.48 674.95C493.11 670.43 480.8 669.58 472.37 674.19C468.29 676.42 471.27 683.05 475.37 680.8C481.79 677.29 488.87 678.17 495.58 680.4L496.14 680.6C495.477 681.449 494.891 682.356 494.39 683.31C490.6 690.67 494.39 702.31 503.61 703.11C516.61 704.22 517.22 687.04 510.16 680.2C509.86 679.91 509.56 679.63 509.24 679.36C512.16 677.95 515.32 676.89 518.11 675.7C520.541 674.671 522.854 673.383 525.01 671.86L525.51 671.99C535.44 674.24 550.94 674.94 554.51 662.91C557.57 652.47 557.86 630.3 574.36 632.35C581.09 633.18 586.61 638.35 593.01 640.22C598.74 641.93 605.37 642 610.07 637.78C613.95 634.3 614.82 629.16 616.01 624.36C616.62 621.88 617.22 618.92 619.24 617.15C622.89 613.96 628.92 615.84 632.99 617C637.44 618.26 640.02 611.46 635.51 610.18ZM506.51 694.77C504.32 696.94 502 695.22 500.83 692.95C499.41 690.19 500.02 687.47 501.83 685.04C502.126 684.643 502.443 684.263 502.78 683.9C507.11 686.7 510.65 690.71 506.55 694.77H506.51ZM514.19 640.77C518.69 636.59 524.96 637.51 527.64 643.25C530.32 648.99 529.14 657.09 525.38 662.15C524.882 662.814 524.33 663.436 523.73 664.01C521.109 663.134 518.687 661.751 516.6 659.94C511.28 655.14 508.27 646.27 514.23 640.74L514.19 640.77Z",
  fill: "#D4AF37"
})), /*#__PURE__*/React.createElement("g", {
  id: "hands"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_22",
  d: "M695.48 221.71L614.76 253.18C599.58 252.05 567.64 247.93 535.94 232.98C500.65 216.34 460.22 216.38 425.94 233.81C346.94 235.7 303.46 225.58 280.26 216L286.38 203.44L204.56 171.54L0 79.86V455.62L71.59 487.52L109.99 395.4L194.32 434.4L210.51 393.26L265.88 434.35L269.65 437.52L264.46 442.91C259.701 447.936 257.049 454.594 257.049 461.515C257.049 468.436 259.701 475.094 264.46 480.12C266.763 482.554 269.538 484.493 272.616 485.819C275.693 487.144 279.009 487.827 282.36 487.827C285.711 487.827 289.027 487.144 292.104 485.819C295.182 484.493 297.957 482.554 300.26 480.12L297.42 483.12C292.661 488.146 290.009 494.804 290.009 501.725C290.009 508.646 292.661 515.304 297.42 520.33V520.33C299.723 522.764 302.498 524.703 305.576 526.029C308.653 527.354 311.969 528.037 315.32 528.037C318.671 528.037 321.987 527.354 325.064 526.029C328.142 524.703 330.917 522.764 333.22 520.33L349.62 503.28L338.36 514.98C333.601 520.006 330.949 526.664 330.949 533.585C330.949 540.506 333.601 547.164 338.36 552.19V552.19C340.663 554.624 343.438 556.563 346.516 557.889C349.593 559.214 352.909 559.897 356.26 559.897C359.611 559.897 362.927 559.214 366.004 557.889C369.082 556.563 371.857 554.624 374.16 552.19L390.35 535.36L383.54 542.44C380.213 545.951 378.359 550.603 378.359 555.44C378.359 560.277 380.213 564.929 383.54 568.44C385.148 570.139 387.086 571.493 389.236 572.418C391.385 573.343 393.7 573.821 396.04 573.821C398.38 573.821 400.695 573.343 402.844 572.418C404.994 571.493 406.932 570.139 408.54 568.44L419.34 557.22C437.89 570.77 452.9 580.66 460.25 583.22C490.88 593.84 490.88 572.57 490.88 572.57C531.79 593.83 552.25 551.31 552.25 551.31C603.39 572.57 603.39 519.41 603.39 519.41C616.17 528.27 625.39 524.21 631.83 516.41C640.6 505.83 641.67 490.9 635.65 478.92L684.53 433.75L705.67 476.97L790 437.97L828.4 523.1L884.95 497.85V126.02L695.48 221.71Z",
  fill: "url(#paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_23",
  d: "M681.9 418.48L592.88 497.6L523.65 369.02L681.9 329.46V418.48Z",
  fill: "#BE7C5E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_24",
  d: "M256.6 210.77C256.6 210.77 285.17 250.33 454.41 240.44L553.32 388.8L619.6 463.37C630.01 475.09 630.6 492.86 620.38 504.74C614.17 511.95 605.24 515.74 592.88 507.49C592.88 507.49 592.88 556.94 543.43 537.16C543.43 537.16 523.65 576.72 484.09 556.94C484.09 556.94 484.09 576.72 454.42 566.83C424.75 556.94 266.49 428.37 266.49 428.37L197.26 378.92L256.6 210.77Z",
  fill: "#FDA57D"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_25",
  d: "M612.66 260.23C612.66 260.23 569.92 260.23 527.66 241.04C489.23 223.61 444.48 225.83 409.02 248.71C380.12 267.36 355.08 298.24 355.55 349.24C355.55 349.24 394.01 388.8 434.67 309.68H464.34C464.34 309.68 492.91 408.59 573.14 398.68C653.37 388.77 672.05 378.9 672.05 378.9L612.66 260.23Z",
  fill: "#BE7C5E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_26",
  d: "M352.999 455.526L349.789 452.316C341.115 443.642 327.053 443.642 318.379 452.316L295.391 475.304C286.718 483.978 286.718 498.04 295.391 506.714L298.601 509.924C307.275 518.597 321.338 518.597 330.011 509.924L352.999 486.936C361.673 478.262 361.673 464.2 352.999 455.526Z",
  fill: "#BE7C5E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_27",
  d: "M321.121 418.163L317.911 414.953C309.237 406.279 295.175 406.279 286.501 414.953L263.513 437.941C254.84 446.614 254.84 460.677 263.513 469.351L266.723 472.561C275.397 481.234 289.46 481.234 298.133 472.561L321.121 449.573C329.795 440.899 329.795 426.837 321.121 418.163Z",
  fill: "#BE7C5E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_28",
  d: "M397.5 480.244L394.29 477.034C385.617 468.36 371.554 468.36 362.881 477.034L334.95 504.965C326.276 513.638 326.276 527.701 334.95 536.374L338.16 539.585C346.834 548.258 360.896 548.258 369.57 539.585L397.5 511.654C406.174 502.98 406.174 488.918 397.5 480.244Z",
  fill: "#BE7C5E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_29",
  d: "M420.923 514.657L418.681 512.415C412.624 506.358 402.804 506.358 396.747 512.415L379.118 530.043C373.061 536.1 373.061 545.921 379.118 551.978L381.36 554.219C387.417 560.276 397.237 560.276 403.294 554.219L420.923 536.591C426.98 530.534 426.98 520.714 420.923 514.657Z",
  fill: "#BE7C5E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_30",
  d: "M780.8 438.26L691.79 477.82L602.77 260.23L681.9 230.56L780.8 438.26Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_31",
  d: "M108.25 388.81L197.26 428.37L286.28 210.78L207.15 181.1L108.25 388.81Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_32",
  d: "M9.34 92.09L207.15 181.1L78.58 477.82L9.34 448.15V92.09Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_33",
  d: "M879.71 141.54L681.9 230.56L810.48 527.27L879.71 497.6V141.54Z",
  fill: "#083175"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 602.157,
  y1: 750.627,
  x2: 308.275,
  y2: 106.358,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 142251,
  y1: -54571.2,
  x2: 140756,
  y2: -57848.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 42037.8,
  y1: -10842,
  x2: 39957.4,
  y2: -15402.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 57616.8,
  y1: 12952.9,
  x2: 52871.1,
  y2: 2549.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 67217.4,
  y1: 33694.5,
  x2: 62471.2,
  y2: 23289.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 26443.8,
  y1: 7763.84,
  x2: 25172.9,
  y2: 4977.74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 530634,
  y1: 307473,
  x2: 530634,
  y2: 51107.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})));

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 885,
    height: 857,
    viewBox: "0 0 885 857",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.c9a7ada1.svg";
export { ForwardRef as ReactComponent };